<template>
  <div class="sub-page-v2 party-page-v2">
    <div class="page-hero-small party-hero">
      <span>{{ $t('party.tag') }}</span>
      <h1>{{ $t('common.party') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <div class="party-list" v-if="articleList.length">
        <router-link class="party-card" v-for="item in articleList" :key="item.id" :to="'/party/' + item.id">
          <div class="party-card-image">
            <img :src="item.image" :alt="item.title" />
          </div>
          <div class="party-card-body">
            <div class="party-meta">{{ item.date }}</div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.summary }}</p>
            <span>{{ $t('common.readMore') }}</span>
          </div>
        </router-link>
      </div>
      <div v-else class="empty-state">{{ $t('party.empty') }}</div>
    </div>
  </div>
</template>

<script>
import { getPartyArticleList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultPartyImage from '@/assets/images/banner5.svg'

export default {
  name: 'PartyIndexV2',
  data() {
    return {
      articleList: []
    }
  },
  created() {
    this.loadArticles()
  },
  methods: {
    loadArticles() {
      getPartyArticleList({ pageNum: 1, pageSize: 20 }).then(({ rows }) => {
        this.articleList = (rows || []).map(item => ({
          id: item.articleId,
          title: item.articleTitle,
          summary: item.summary || '',
          date: item.publishTime || '',
          image: resolveFileUrl(item.coverUrl, defaultPartyImage)
        }))
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.party-page-v2 .party-hero {
  min-height: 220px;
  flex-direction: column;
  background:
    radial-gradient(circle at 76% 24%, rgba(255,255,255,0.16), transparent 28%),
    linear-gradient(135deg, #7f1d1d, #b91c1c 58%, #991b1b);

  span {
    display: block;
    margin-bottom: 10px;
    color: rgba(255,255,255,0.74);
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 2px;
  }
}

.party-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.party-card {
  display: flex;
  align-items: stretch;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  color: inherit;
  box-shadow: 0 6px 22px rgba(15, 23, 42, 0.05);
  transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;

  &:hover {
    transform: translateX(6px);
    border-color: rgba(239, 0, 18, 0.25);
    box-shadow: 0 14px 36px rgba(127, 29, 29, 0.1);

    img {
      transform: scale(1.05);
    }

    h3,
    span {
      color: #ef0012;
    }
  }
}

.party-card-image {
  width: 260px;
  min-height: 180px;
  flex-shrink: 0;
  overflow: hidden;
  background: #f8fafc;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.5s;
  }
}

.party-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  padding: 26px 30px;

  .party-meta {
    margin-bottom: 12px;
    color: #b91c1c;
    font-size: 13px;
    font-weight: 700;
  }

  h3 {
    color: #0f172a;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5;
    transition: color 0.2s;
  }

  p {
    margin-top: 12px;
    color: #64748b;
    font-size: 15px;
    line-height: 1.8;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  span {
    align-self: flex-start;
    margin-top: 18px;
    color: #334155;
    font-size: 14px;
    font-weight: 800;
    transition: color 0.2s;
  }
}

.empty-state {
  padding: 70px 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 18px;
  color: #94a3b8;
  text-align: center;
  background: #fff;
}

@media (max-width: 760px) {
  .party-card {
    flex-direction: column;

    &:hover {
      transform: translateY(-4px);
    }
  }

  .party-card-image {
    width: 100%;
    height: 210px;
    min-height: 0;
  }

  .party-card-body {
    padding: 22px;

    h3 {
      font-size: 20px;
    }
  }
}

@media (max-width: 640px) {
  .party-card-image {
    height: 190px;
  }
}
</style>
